import { useEffect, useState } from "react";
import { useParams } from 'react-router-dom';
import CustomPanelTab from "../../common/CustomPanelTab";
import IndiChallenge from "../IndiChallenge";
import IndiChallengeParticipant from "../IndiChallengeParticipant";


function PanelIndiChallenge() {
    const { tab } = useParams();
    const [activeTab, setActiveTab] = useState(null);
    const tabs = [
        { "name": "Challenges", "path": "/challenges" },
        { "name": "Participants", "path": "/participants" },
    ];

    useEffect(() => {
        const link = (process.env.REACT_APP_ENVIRONMENT === "PROD" ? process.env.REACT_APP_ADMIN_URL : process.env.REACT_APP_APP_ADMIN_URL_DEV);
        activeTab?.path && window.history.pushState({}, "", `${link}indi-challenges-panel${activeTab?.path}`);
    }, [activeTab]);

    return (
        <div id="indi-challenges-panel" className="custom-panel">
            <div className="panel-header">
                <h4>Indi Challenges</h4>
            </div>
            <CustomPanelTab tabs={tabs}
                defaultTab={tabs?.find(t => t?.path == ('/' + tab))}
                setActiveTab={setActiveTab} />

            <div className="panel-content">
                {
                    activeTab?.name == "Challenges" && <IndiChallenge />
                }
                {
                    activeTab?.name == "Participants" && <IndiChallengeParticipant />
                }

            </div>
        </div>
    );
}

export default PanelIndiChallenge;